module.exports = __webpack_public_path__ + "images/category_lp/common/reason2-jewel@2x_c638f7a140fc49b225cccbb599fdc43b.jpg";